import Vue from 'vue';
const store = {
  state: {
    count: 0
  },
  setCount(newCount) {
    Vue.set(this.state, 'count', newCount); // Use Vue.set to make state updates reactive
  }
};
export default store;


// WEBPACK FOOTER //
// ./ClientApp/app/costcoservicerequests/store.js